import React, { useEffect } from "react";
import OpenAI from "openai";
import Axios from "axios";
import { useState } from "react";
import chatBotIcon from "./images/chatbot-icon.png";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import { useAuth } from "./Context/AuthContext";

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { authUser, setUser, isLogin, setLogin } = useAuth();
  const toggleChatBot = () => {
    if (isLogin) {
      setIsOpen(!isOpen);
      console.log(JSON.stringify(authUser));
    } else {
      alert("Please Login to use ChatBot");
    }
  };

  const onpressingenter = (event) => {
    if (event.keyCode === 13) askchatbot();
  };
  const askchatbot = async () => {
    let prompt = document.getElementById("askcbinput").value;
    if (prompt === "") return;
    document.getElementById("askcbinput").value = "";
    let userQuery = document.createElement("p");
    userQuery.classList.add("userQuery");
    userQuery.innerText = prompt;
    userQuery.style.backgroundColor = "#f7ece4";
    userQuery.style.fontWeight = "600";
    document.getElementById("chats").append(userQuery);
    let response = await Axios.post(
      "https://fitness-junction-bots.onrender.com/api/askcb",
      { prompt: prompt }
    );
    // console.log(response.data.response);
    let botAns = document.createElement("p");
    botAns.innerText = response.data.response;
    // botAns.style.backgroundColor = "#b1b1b1";
    document.getElementById("chats").append(botAns);
  };

  return (
    <>
      <div
        className={`chat-bot-container  ${
          isOpen ? "open" : "rotate-hor-center rotate-tl bounce-in-top"
        }`}
      >
        <div className="chat-bot-toggle" onClick={toggleChatBot}>
          {isOpen ? (
            <ExpandCircleDownOutlinedIcon
              alt="Close Icon"
              className=" toggle-icon fs-1"
            />
          ) : (
            // <img src={chatBotIcon} alt="Close Icon" />
            <img src={chatBotIcon} alt="Open Icon" />
          )}
        </div>
        <div className="chat-bot-content">
          <div
            id="chats"
            className={`content-screen ${isOpen ? "add-visibility" : ""}`}
          >
            <h4 className="mb-5 " id="bot-intro">
              {`Welcome! `}
            </h4>
            <p className=" bg-light "></p>
          </div>
          <div className={`chat-bot-footer ${isOpen ? "add-visibility" : ""}`}>
            <input
              type="text"
              id="askcbinput"
              onKeyDown={onpressingenter}
              placeholder="Ask your query"
            />
            <button type="button" id="askcbbtn" onClick={askchatbot}>
              <SendRoundedIcon />
            </button>
          </div>
        </div>
      </div>

      {/* <button type="button" id="opencbbtn" onClick={openchatbot}>
        <span className="material-symbols-outlined">smart_toy</span>
      </button>
      <div id="cbcontainer" style={{ display: "none" }}>
        <div id="chats"></div>
        <input type="text" id="askcbinput" onKeyDown={onpressingenter} />
        <button type="button" id="askcbbtn" onClick={askchatbot}>
          <span className="material-symbols-outlined">send</span>
        </button>
      </div> */}
    </>
  );
};

export default Chatbot;
